import { get } from 'lodash';
import { LogoImage } from '../../../types';
import { useConstructorContextState } from './useConstructorContextState';

export const useGetWhitelabelLogo = (): LogoImage | undefined => {
  const state = useConstructorContextState();

  return get(state, ['whitelabelLogo'], undefined);
};
